<div class="header d-flex justify-content-between">
  <em>
    {{entry?.commentedOn | date:'dd MMM y (HH:mm)'}}
  </em>
  {{entry?.commentedByUser}}
</div>
